import React, { ReactNode } from 'react';
import { ModularSelect } from '../../../../../../shared';

export type TSelectableItemProps = {
  addonPre?: ReactNode;
  icon?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  addonCenter?: ReactNode;
  addonEnd?: ReactNode;
  addonContent?: ReactNode;
  checked: boolean;
};

export const SelectableItem = ({
  addonCenter,
  addonContent,
  addonEnd,
  addonPre,
  icon,
  title,
  subtitle,
  checked,
}: TSelectableItemProps) => {
  return (
    <ModularSelect
      title={{
        type: title,
        icon,
      }}
      subtitle={subtitle}
      checkbox={addonPre}
      checked={checked}
      endContent={addonEnd}
      centerContent={addonCenter}
      collapseContent={addonContent}
    />
  );
};
